import { motion } from "motion/react";
import { landingImages } from "@/config/assets";
import { useI18n } from "@/i18n/I18nContext";
import { ImageWithFallback } from "@/landing/components/ImageWithFallback";

const USE_CASE_IMAGES = [
  landingImages.useSnacks,
  landingImages.useCoffee,
  landingImages.useCosmetics,
  landingImages.useHousehold,
] as const;

export function UseCasesSection() {
  const { messages } = useI18n();
  const u = messages.useCases;

  return (
    <section id="use-cases" className="overflow-hidden bg-white py-32">
      <div className="container mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-16 text-center"
        >
          <h2 className="mb-6 text-4xl text-[#111111] lg:text-6xl">
            {u.heading}
          </h2>
          <p className="mx-auto max-w-2xl text-xl text-gray-600">
            {u.subheading}
          </p>
        </motion.div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {u.cards.map((card, index) => (
            <motion.div
              key={card.title}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ y: -12, transition: { duration: 0.3 } }}
              className="group relative"
            >
              <div className="relative aspect-[3/4] overflow-hidden rounded-3xl shadow-lg">
                <ImageWithFallback
                  src={USE_CASE_IMAGES[index]}
                  alt={card.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />

                <div className="absolute right-0 bottom-0 left-0 p-6 text-white">
                  <div className="mb-3 text-4xl">{card.emoji}</div>
                  <h3 className="mb-2 text-2xl">{card.title}</h3>
                  <p className="text-white/80">{card.description}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
